import { render, staticRenderFns } from "./RegistrationIframe.vue?vue&type=template&id=4711dc90&"
import script from "./RegistrationIframe.vue?vue&type=script&lang=ts&"
export * from "./RegistrationIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports